import PriorityControl from '@atom/components/common/PriorityControl';
import WorkOrderStatusPill from '@atom/components/common/workOrderDetail/workOrderStatusPill/WorkOrderStatusPill';
import { MapWorkOrder } from '@atom/types/map';
import timeUtilities from '@atom/utilities/timeUtilities';

import classes from './drawerContent.module.css';

interface Props {
  workOrder: MapWorkOrder;
  navigateToWorkOrder: (id: string) => void;
}

const WorkOrderListItem = ({ workOrder, navigateToWorkOrder }: Props) => {
  const { name, statusId, priorityId, dueDate, assigneeCount, taskCount, id } =
    workOrder;

  return (
    <div
      className={classes.listItem}
      onClick={(): void => navigateToWorkOrder(id)}
    >
      <div className={classes.name}>{name}</div>
      <div className={classes.priorityStatusContainer}>
        <div className={classes.priorityStatusIcon}>
          <PriorityControl disabled priorityId={priorityId} />
        </div>
        <WorkOrderStatusPill
          statusId={statusId}
          className="dashboard-map-list"
        />
      </div>
      <div className={classes.workRowDetailsContainer}>
        <div className={classes.workDetailContent}>
          Due Date: {timeUtilities.setDisplayDate(dueDate)}
        </div>
        <div className={classes.workDetailContent}>Team: {assigneeCount}</div>
        <div className={classes.workDetailContent}>Tasks: {taskCount}</div>
      </div>
    </div>
  );
};

export default WorkOrderListItem;
